import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Searchbar = _resolveComponent("Searchbar")!

  return (_ctx.shown)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["search-overlay", { visible: _ctx.visible }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
      }, [
        _createVNode(_component_Searchbar, {
          "auto-focus": true,
          onSelect: _ctx.close
        }, null, 8, ["onSelect"])
      ], 2))
    : _createCommentVNode("", true)
}